import "./Pages.css";
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { auth } from '../Admin/Api.js';

export const AboutMe = () => {
  const navigate = useNavigate();

  useEffect(() => {
    auth().then(isAuth => {
      if (!isAuth) {
        handleLogout()
      }
    });
  }, [navigate]);

  const handleLogout = () => {
    // Alle Daten aus localStorage entfernen und den Login-Status zurücksetzen
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('userId'); // Optional, falls du die User-ID im LocalStorage speicherst

    // Benutzer zum Login weiterleiten
    navigate("/login");
  };


  return (
    <div>
      <div className="info-box">
        <h1 style={{ marginBottom: '20px' }}>GymDich – Dein Körper, Deine Bewegung</h1>

        <p>
          Stell Dir ein Training vor, das genau auf Dich zugeschnitten ist:
          mal kraftvoll und intensiv, mal ruhig und kontrolliert, aber immer mit dem Ziel,
          Deinen Körper ganzheitlich zu stärken. Bei GymDich erwartet Dich ein Mix aus Balance,
          präzisen Bewegungen und gezielter Kräftigung – mit und ohne Geräte.
          Unsere Stunden bringen nicht nur Deine Muskulatur in Form,
          sondern geben Dir auch Raum für Mobilisation, Dehnung und Entspannung.
          So spürst Du jede Übung bewusst und gehst gestärkt, entspannt und mit einem guten Körpergefühl
          nach Hause.
        </p>
        <p>
          Erlebe, wie gut es sich anfühlt, im eigenen Tempo immer stärker und beweglicher zu werden!
        </p>
      </div>
      <div className="info-box">
        <h2 style={{ textAlign: 'left' }}>Cordula Schumann</h2>
        <p style={{ textIndent: '0', margin: 0 }}>
          Übungsleiterin C: Gesundheit und Fitness<br />
          Übungsleiterin B:<br />
          <span style={{ marginLeft: '20px', display: 'block' }}>- Gesundheitstraining Haltungs- und Bewegungssystem</span>
          <span style={{ marginLeft: '20px', display: 'block' }}>- Entspannung</span>
          Fortbildung: Streching Instructor
        </p>
        <p></p>

        <p>☎️ Tel.: 0731 166-3765</p>
        <p>✉️ cordula.schumann@ulm-netze.de</p>
      </div>
    </div>
  );
};
